kv.controller('invoiceEmailTemplateListCtrl', function ($element, $attrs, $scope, $injector) {
	return new dictionaryListCtrl($element, $attrs, $scope, $injector, {
		primaryKey: "email_template_id",
		entity: "invoice_email_template"
	});
});
